import React from 'react'
import mac from "./img/vigho.png"
import web from "./img/Vigho.gif"
import Image from "../../../../Components/Image"


function Vigho() {
    return (
        <div className=" animated fadeInIn">
            <div id="work_content">
                <div className="work_title">Vigho</div>
                <div className="work_type">Web Application</div>
                <div className="process_title">
                    Overview
                </div>
                <div className="process_text">
                    <p>
                        Chop Now, Pay Later!<br />
                        Vigho heralds the ability to provide users with the opportunity of buying meals, foodstuff, pharmaceuticals and paying later at 0% interest with no signup fee.
                    </p>
                    <p>
                        The Vigho APP provides these services in form of the following products:
                        <ul>
                            <li>VighoCredit</li>
                            <li>VighoPay</li>
                            <li>VighoCards</li>
                            <li>VighoSure</li>
                        </ul>
                    </p>
                    <a href='https://www.govigho.com' className="work_btn" target='_blank'>Visit Website</a>
                </div>
            </div>
            <div id="images">
                <Image src={mac} />
            </div>
            <div id="work_content">
                <div className="process_title">
                    Resources
                </div>
                <div className="process_text">

                    <p>
                        <div className="dev_title">Front End</div>
                        <div className="dev_info"> Mobile : React-native, Expo, SASS, Redux etc.<br /> Website : React, SASS</div>
                    </p>
                    <p>
                        <div className="dev_title">Back End</div>
                        <div className="dev_info">NodeJs, Express, PostgreSQL, AWS.</div>
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={web} />
            </div>
        </div>
    )
}

export default Vigho